import React from 'react'
import { Chart } from "react-google-charts";
// import { buildProdNoWorkTableView } from '../insights_functions';

const InsightSalesTableView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);
        const chartData = viewData.ViewData[currentOption].ChartData;

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <Chart
                chartType="Table"
                data={chartData}
                options={{
                    title: "",
                    allowHtml: true,
                    showRowNumber: true,
                    legend: { position: "bottom" },
                    pageSize: 10,
                }}
                formatters={
                    [
                    {
                        type: "NumberFormat",
                        column: 1, // the column index you want to format
                        options: {
                        fractionDigits: 2, // limits to 1 decimal place
                        },
                    },
                    {
                        type: "NumberFormat",
                        column: 2, // the column index you want to format
                        options: {
                        fractionDigits: 2, // limits to 1 decimal place
                        },
                    },
                    {
                        type: "NumberFormat",
                        column: 3, // the column index you want to format
                        options: {
                        fractionDigits: 2, // limits to 1 decimal place
                        },
                    },
                    {
                        type: "NumberFormat",
                        column: 4, // the column index you want to format
                        options: {
                        fractionDigits: 2, // limits to 1 decimal place
                        },
                    },
                    {
                        type: "ColorFormat",
                        column: 4,
                        options: {
                          width: 120,
                        },
                        ranges: [
                          [null, 79.99999, "white", "red"],
                          [80, null, "white", "green"],
                        ],
                      },
                    ]
                }
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightSalesTableView
